import styled from 'styled-components';

export const AvatarBlock = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;
